// CHIGLE i18n dictionary — English + Hindi
// Hindi translations crafted to preserve the editorial brand feel.

export const TRANSLATIONS = {
    en: {
        // Header
        "nav.mission": "Mission",
        "nav.how": "How It Works",
        "nav.impact": "Impact",
        "nav.founder": "Founder",
        "nav.join": "Join",
        "header.cta": "Early Access",
        "lang.switch.label": "Language",
        "lang.en": "English",
        "lang.hi": "हिन्दी",

        // Hero
        "hero.eyebrow": "AI-Optimised Waste Intelligence",
        "hero.headline.line1": "Ain't",
        "hero.headline.line2.prefix": "No",
        "hero.headline.line2.accent": "Waste",
        "hero.tagline":
            "Every piece of waste is a resource waiting to be found. CHIGLE connects the dots.",
        "hero.subline":
            "AI-powered waste intelligence connecting generators and collectors.",
        "hero.cta.primary": "Join Early Access",
        "hero.cta.secondary": "Read our mission",
        "hero.scroll": "Scroll",

        // Problem
        "problem.chapter": "The Problem",
        "problem.headline.prefix": "India wastes",
        "problem.headline.accent": "what the",
        "problem.headline.suffix": "world needs.",
        "problem.p1":
            "Every day, thousands of tonnes of recoverable material — used cooking oil, paper, plastic, e-waste — are burned, buried, or forgotten. Not because collection is impossible. Because the system connecting generators to processors is broken, invisible, and unorganised.",
        "problem.p2":
            "The kabadiwalla knows the streets. The restaurant owner has the oil. The refinery needs the feedstock. Nobody is connecting them intelligently.",
        "problem.until": "Until now.",
        "problem.gap.label": "The Gap",
        "problem.gap.body":
            "Collection is scattered, cash-based, and invisible to data. Collectors have no routing intelligence. Generators have no reliable pickup. Processors have no forecasting.",
        "problem.fix.label": "The Fix",
        "problem.fix.body":
            "CHIGLE is the technology layer the waste supply chain has never had — AI-optimised routing, demand prediction, quality verification, smart matching.",

        // How It Works
        "how.chapter": "How It Works",
        "how.headline.prefix": "Three steps.",
        "how.headline.accent": "One",
        "how.headline.suffix": "closed loop.",
        "how.intro": "Built for the streets of India, designed for the planet.",
        "how.chapterLabel": "Chapter",
        "how.step1.title": "Generate",
        "how.step1.body":
            "Restaurants, schools, offices, and households register their waste output on CHIGLE — type, volume, frequency. We turn invisible flows into visible data.",
        "how.step2.title": "Connect",
        "how.step2.body":
            "Our AI matches generators with the nearest certified collectors, optimises pickup routes, schedules in real time, and verifies quality at handoff.",
        "how.step3.title": "Restore",
        "how.step3.body":
            "Collected material reaches the right processor — biodiesel refiners, paper mills, recyclers. Nothing goes to landfill. The loop closes.",

        // Stats
        "stats.chapter": "The Scale of It",
        "stats.headline.prefix": "The numbers are",
        "stats.headline.accent": "staggering",
        "stats.tonnes.label": "Tonnes annually",
        "stats.tonnes.sub":
            "Municipal solid waste generated across India every year.",
        "stats.value.label": "Value recovered",
        "stats.value.sub":
            "From most of that waste today — burned, buried, or forgotten.",
        "stats.potential.label": "Potential",
        "stats.potential.sub":
            "When nothing goes to landfill. When every kilo finds its second life.",

        // Founder
        "founder.chapter": "The Founder",
        "founder.title.accent": "Ridhi",
        "founder.title.last": "Tiwari",
        "founder.intro":
            "Founder of CHIGLE, building the intelligence layer for the circular economy.",
        "founder.bio":
            "Driven by a passion for AI, Data Science, Interaction Design, and Human-Centered Product Design, Ridhi creates technology that makes sustainability seamless, scalable, and impactful.",
        "founder.quote":
            '"The most powerful innovation is technology that people naturally',
        "founder.quote.accent": 'want to use."',
        "founder.cred1.label": "Founder",
        "founder.cred1.value": "Building CHIGLE",
        "founder.cred2.label": "Published Author",
        "founder.cred2.value": "Where Time Leaned to Stay",
        "founder.linkedin": "Connect on LinkedIn",
        "founder.badge": "Founder · India",

        // Waitlist
        "waitlist.badge": "Early Access · Delhi NCR Pilot",
        "waitlist.headline.prefix": "Be part of",
        "waitlist.headline.accent": "the loop.",
        "waitlist.intro":
            "We're onboarding our first restaurants, schools, and collectors in Delhi NCR. Join the waitlist and help us build this together.",
        "waitlist.count.one": "person has already joined",
        "waitlist.count.many": "people have already joined",
        "waitlist.benefits.1": "Priority access in our pilot rollout",
        "waitlist.benefits.2": "Direct line to the founding team",
        "waitlist.benefits.3": "Free onboarding & training",
        "waitlist.benefits.4": "No spam · only meaningful updates",
        "waitlist.choose": "Choose your role",
        "waitlist.role.generator": "Generator",
        "waitlist.role.generator.blurb":
            "Restaurants, schools, offices, households producing waste.",
        "waitlist.role.collector": "Collector",
        "waitlist.role.collector.blurb":
            "Kabadiwallas, scrap dealers, fleet operators on the ground.",
        "waitlist.role.processor": "Processor",
        "waitlist.role.processor.blurb":
            "Refiners, paper mills, recyclers turning waste into value.",
        "waitlist.joiningAs": "Joining as a",
        "waitlist.field.fullName": "Full name",
        "waitlist.field.fullName.ph": "Your name",
        "waitlist.field.email": "Email",
        "waitlist.field.email.ph": "you@domain.com",
        "waitlist.field.phone": "Phone",
        "waitlist.field.phone.ph": "+91 ...",
        "waitlist.field.city": "City",
        "waitlist.field.organisation": "Organisation",
        "waitlist.field.organisation.ph": "Restaurant / School / Office",
        "waitlist.field.wasteType": "Primary waste type",
        "waitlist.field.wasteType.ph": "Used oil, paper, organic...",
        "waitlist.field.wasteVolume": "Approx. volume / week",
        "waitlist.field.wasteVolume.ph": "e.g., 40 kg / 20 L",
        "waitlist.field.vehicle": "Vehicle / capacity",
        "waitlist.field.vehicle.ph": "Cycle cart, mini-truck...",
        "waitlist.field.areas": "Areas you cover",
        "waitlist.field.areas.ph": "Lajpat Nagar, GK, Saket...",
        "waitlist.field.capacity": "Facility capacity",
        "waitlist.field.capacity.ph": "Tonnes / day",
        "waitlist.field.material": "Material needed",
        "waitlist.field.material.ph": "UCO, mixed paper, HDPE...",
        "waitlist.field.message": "Anything else?",
        "waitlist.field.message.ph": "Tell us your story (optional)",
        "waitlist.disclaimer":
            "By submitting, you agree to be contacted about CHIGLE's early access programme. No spam.",
        "waitlist.submit": "Join the loop",
        "waitlist.submit.loading": "Submitting...",
        "waitlist.error.required": "Please share your name, email, and phone.",
        "waitlist.error.generic": "Something went wrong. Try again.",
        "waitlist.error.network":
            "We couldn't reach the server. Check your connection and try again.",
        "waitlist.error.timeout":
            "The request took too long. Please try again in a moment.",
        "waitlist.success.toast": "You're in. We'll be in touch soon.",
        "waitlist.success.eyebrow": "Welcome to the loop",
        "waitlist.success.title": "You're in.",
        "waitlist.success.body.prefix": "We've received your details as a",
        "waitlist.success.body.suffix":
            ". Our team will reach out soon as we begin onboarding in Delhi NCR.",
        "waitlist.success.nextSteps":
            "Watch your inbox — every confirmed signup gets a personal hello from the founding team.",
        "waitlist.success.again": "Add another person",

        // Footer
        "footer.tagline":
            "The technology layer the waste supply chain has never had.",
        "footer.explore": "Explore",
        "footer.contact": "Contact",
        "footer.location": "Delhi NCR · India",
        "footer.copy.suffix": "All rights reserved.",
        "footer.privacy": "Privacy Policy",
        "footer.terms": "Terms of Service",
        "footer.builtFor": "Built for India · designed for the planet.",
    },

    hi: {
        // Header
        "nav.mission": "मिशन",
        "nav.how": "कैसे काम करता है",
        "nav.impact": "इम्पैक्ट",
        "nav.founder": "फ़ाउंडर",
        "nav.join": "जुड़ें",
        "header.cta": "अर्ली एक्सेस",
        "lang.switch.label": "भाषा",
        "lang.en": "English",
        "lang.hi": "हिन्दी",

        // Hero
        "hero.eyebrow": "AI-आधारित वेस्ट इंटेलिजेंस",
        "hero.headline.line1": "अब",
        "hero.headline.line2.prefix": "नो",
        "hero.headline.line2.accent": "वेस्ट",
        "hero.tagline":
            "हर कचरा एक संसाधन है — बस सही जगह पहुंचने के इंतज़ार में। CHIGLE उन सब को जोड़ता है।",
        "hero.subline":
            "AI-संचालित वेस्ट इंटेलिजेंस, जो जनरेटर्स और कलेक्टर्स को जोड़ती है।",
        "hero.cta.primary": "अर्ली एक्सेस लें",
        "hero.cta.secondary": "हमारा मिशन पढ़ें",
        "hero.scroll": "स्क्रॉल करें",

        // Problem
        "problem.chapter": "समस्या",
        "problem.headline.prefix": "भारत बर्बाद कर रहा है",
        "problem.headline.accent": "वो",
        "problem.headline.suffix": "जो दुनिया को चाहिए।",
        "problem.p1":
            "हर रोज़ हज़ारों टन ऐसी चीज़ें — इस्तेमाल किया हुआ कुकिंग ऑयल, पेपर, प्लास्टिक, ई-वेस्ट — जला दी जाती हैं, दबा दी जाती हैं, या भुला दी जाती हैं। इसलिए नहीं कि कलेक्शन नामुमकिन है। बल्कि इसलिए कि जनरेटर्स को प्रोसेसर्स से जोड़ने वाला सिस्टम टूटा हुआ, अदृश्य और अनऑर्गनाइज़्ड है।",
        "problem.p2":
            "कबाड़ीवाला गलियों को जानता है। रेस्टोरेंट के पास तेल है। रिफ़ाइनरी को कच्चा माल चाहिए। कोई उन्हें समझदारी से जोड़ नहीं रहा।",
        "problem.until": "अब तक।",
        "problem.gap.label": "क्या अधूरा है",
        "problem.gap.body":
            "कलेक्शन बिखरा हुआ है, कैश-बेस्ड है, और डेटा के लिए अदृश्य है। कलेक्टर्स के पास रूटिंग इंटेलिजेंस नहीं है। जनरेटर्स के पास भरोसेमंद पिकअप नहीं है। प्रोसेसर्स के पास फ़ोरकास्टिंग नहीं है।",
        "problem.fix.label": "हमारा हल",
        "problem.fix.body":
            "CHIGLE वो तकनीकी लेयर है जो वेस्ट सप्लाई चेन के पास कभी नहीं रही — AI-ऑप्टिमाइज़्ड रूटिंग, डिमांड प्रेडिक्शन, क्वॉलिटी वेरिफ़िकेशन और स्मार्ट मैचिंग।",

        // How It Works
        "how.chapter": "कैसे काम करता है",
        "how.headline.prefix": "तीन कदम।",
        "how.headline.accent": "एक",
        "how.headline.suffix": "पूरा लूप।",
        "how.intro": "भारत की गलियों के लिए बना, धरती के लिए डिज़ाइन किया गया।",
        "how.chapterLabel": "चैप्टर",
        "how.step1.title": "जनरेट",
        "how.step1.body":
            "रेस्टोरेंट, स्कूल, ऑफ़िस और घर अपना वेस्ट CHIGLE पर रजिस्टर करते हैं — प्रकार, मात्रा, आवृत्ति। हम अदृश्य प्रवाह को दिखने वाले डेटा में बदल देते हैं।",
        "how.step2.title": "कनेक्ट",
        "how.step2.body":
            "हमारा AI जनरेटर्स को सबसे क़रीबी सर्टिफ़ाइड कलेक्टर्स से मैच करता है, पिकअप रूट्स को ऑप्टिमाइज़ करता है, रियल-टाइम शेड्यूल करता है और हैंडऑफ़ पर क्वॉलिटी वेरिफ़ाई करता है।",
        "how.step3.title": "रिस्टोर",
        "how.step3.body":
            "इकट्ठा किया गया मटीरियल सही प्रोसेसर तक पहुँचता है — बायोडीज़ल रिफ़ाइनर्स, पेपर मिल्स, रीसायक्लर्स। कुछ भी लैंडफ़िल नहीं जाता। लूप पूरा होता है।",

        // Stats
        "stats.chapter": "स्केल कितना बड़ा है",
        "stats.headline.prefix": "नंबर",
        "stats.headline.accent": "चौंकाने वाले",
        "stats.headline.suffix": "हैं।",
        "stats.tonnes.label": "टन सालाना",
        "stats.tonnes.sub":
            "भारत में हर साल पैदा होने वाला म्यूनिसिपल सॉलिड वेस्ट।",
        "stats.value.label": "रिकवर हुई वैल्यू",
        "stats.value.sub":
            "इसमें से ज़्यादातर वेस्ट से आज — जला दिया गया, दफ़न कर दिया गया, या भुला दिया गया।",
        "stats.potential.label": "पोटेंशियल",
        "stats.potential.sub":
            "जब कुछ भी लैंडफ़िल न जाए। जब हर किलो को उसका दूसरा जीवन मिले।",

        // Founder
        "founder.chapter": "फ़ाउंडर",
        "founder.title.accent": "रिद्धि",
        "founder.title.last": "तिवारी",
        "founder.intro":
            "CHIGLE की फ़ाउंडर, सर्कुलर इकॉनमी के लिए इंटेलिजेंस लेयर बना रही हैं।",
        "founder.bio":
            "AI, डेटा साइंस, इंटरैक्शन डिज़ाइन और ह्यूमन-सेंटर्ड प्रोडक्ट डिज़ाइन के प्रति जुनून से प्रेरित, रिद्धि ऐसी तकनीक बनाती हैं जो सस्टेनेबिलिटी को सहज, स्केलेबल और प्रभावशाली बनाती है।",
        "founder.quote":
            '"सबसे शक्तिशाली इनोवेशन वो तकनीक है जिसे लोग स्वाभाविक रूप से',
        "founder.quote.accent": 'इस्तेमाल करना चाहें।"',
        "founder.cred1.label": "फ़ाउंडर",
        "founder.cred1.value": "CHIGLE बना रही हैं",
        "founder.cred2.label": "पब्लिश्ड ऑथर",
        "founder.cred2.value": "Where Time Leaned to Stay",
        "founder.linkedin": "LinkedIn पर जुड़ें",
        "founder.badge": "फ़ाउंडर · भारत",

        // Waitlist
        "waitlist.badge": "अर्ली एक्सेस · दिल्ली NCR पायलट",
        "waitlist.headline.prefix": "बनिए",
        "waitlist.headline.accent": "इस लूप का हिस्सा।",
        "waitlist.intro":
            "हम दिल्ली NCR में अपने पहले रेस्टोरेंट्स, स्कूल्स और कलेक्टर्स को ऑनबोर्ड कर रहे हैं। वेटलिस्ट में जुड़िए और हमारे साथ मिलकर इसे बनाइए।",
        "waitlist.count.one": "व्यक्ति पहले से जुड़ चुका है",
        "waitlist.count.many": "लोग पहले से जुड़ चुके हैं",
        "waitlist.benefits.1": "पायलट रोल-आउट में प्रायॉरिटी एक्सेस",
        "waitlist.benefits.2": "फ़ाउंडिंग टीम से सीधा संपर्क",
        "waitlist.benefits.3": "फ़्री ऑनबोर्डिंग और ट्रेनिंग",
        "waitlist.benefits.4": "कोई स्पैम नहीं · केवल अर्थपूर्ण अपडेट्स",
        "waitlist.choose": "अपनी भूमिका चुनें",
        "waitlist.role.generator": "जनरेटर",
        "waitlist.role.generator.blurb":
            "रेस्टोरेंट्स, स्कूल्स, ऑफ़िस, घर — जो वेस्ट जनरेट करते हैं।",
        "waitlist.role.collector": "कलेक्टर",
        "waitlist.role.collector.blurb":
            "कबाड़ीवाले, स्क्रैप डीलर्स, फ़्लीट ऑपरेटर्स — ज़मीन पर मौजूद।",
        "waitlist.role.processor": "प्रोसेसर",
        "waitlist.role.processor.blurb":
            "रिफ़ाइनर्स, पेपर मिल्स, रीसायक्लर्स — जो वेस्ट को वैल्यू में बदलते हैं।",
        "waitlist.joiningAs": "जुड़ रहे हैं एक",
        "waitlist.field.fullName": "पूरा नाम",
        "waitlist.field.fullName.ph": "आपका नाम",
        "waitlist.field.email": "ईमेल",
        "waitlist.field.email.ph": "you@domain.com",
        "waitlist.field.phone": "फ़ोन",
        "waitlist.field.phone.ph": "+91 ...",
        "waitlist.field.city": "शहर",
        "waitlist.field.organisation": "संगठन",
        "waitlist.field.organisation.ph": "रेस्टोरेंट / स्कूल / ऑफ़िस",
        "waitlist.field.wasteType": "मुख्य वेस्ट प्रकार",
        "waitlist.field.wasteType.ph": "Used oil, paper, organic...",
        "waitlist.field.wasteVolume": "लगभग मात्रा / सप्ताह",
        "waitlist.field.wasteVolume.ph": "जैसे 40 kg / 20 L",
        "waitlist.field.vehicle": "वाहन / क्षमता",
        "waitlist.field.vehicle.ph": "साइकल कार्ट, मिनी-ट्रक...",
        "waitlist.field.areas": "आप जिन इलाकों को कवर करते हैं",
        "waitlist.field.areas.ph": "लाजपत नगर, GK, साकेत...",
        "waitlist.field.capacity": "फ़ैसिलिटी क्षमता",
        "waitlist.field.capacity.ph": "टन / दिन",
        "waitlist.field.material": "ज़रूरी मटीरियल",
        "waitlist.field.material.ph": "UCO, mixed paper, HDPE...",
        "waitlist.field.message": "कुछ और कहना है?",
        "waitlist.field.message.ph": "अपनी कहानी हमें बताइए (वैकल्पिक)",
        "waitlist.disclaimer":
            "सबमिट करके आप CHIGLE के अर्ली एक्सेस प्रोग्राम के बारे में संपर्क में रहने पर सहमत हैं। कोई स्पैम नहीं।",
        "waitlist.submit": "लूप में जुड़ें",
        "waitlist.submit.loading": "भेज रहे हैं...",
        "waitlist.error.required": "कृपया अपना नाम, ईमेल और फ़ोन भरें।",
        "waitlist.error.generic": "कुछ ग़लत हो गया। दोबारा कोशिश करें।",
        "waitlist.error.network":
            "हम सर्वर तक नहीं पहुँच पाए। अपना कनेक्शन जाँचें और दोबारा कोशिश करें।",
        "waitlist.error.timeout":
            "रिक्वेस्ट में बहुत समय लगा। कुछ देर में फिर कोशिश करें।",
        "waitlist.success.toast": "आप जुड़ गए हैं। हम जल्द संपर्क करेंगे।",
        "waitlist.success.eyebrow": "लूप में स्वागत है",
        "waitlist.success.title": "आप जुड़ गए हैं।",
        "waitlist.success.body.prefix": "हमें आपकी डिटेल्स मिल गई हैं —",
        "waitlist.success.body.suffix":
            "के तौर पर। दिल्ली NCR में ऑनबोर्डिंग शुरू होते ही हमारी टीम जल्द संपर्क करेगी।",
        "waitlist.success.nextSteps":
            "अपना इनबॉक्स देखते रहिए — हर कन्फ़र्म्ड साइन-अप को फ़ाउंडिंग टीम से व्यक्तिगत हैलो मिलता है।",
        "waitlist.success.again": "और किसी को जोड़ें",

        // Footer
        "footer.tagline":
            "वेस्ट सप्लाई चेन की वो टेक्नोलॉजी लेयर जो पहले कभी थी ही नहीं।",
        "footer.explore": "एक्सप्लोर",
        "footer.contact": "संपर्क",
        "footer.location": "दिल्ली NCR · भारत",
        "footer.copy.suffix": "सर्वाधिकार सुरक्षित।",
        "footer.privacy": "प्राइवेसी पॉलिसी",
        "footer.terms": "टर्म्स ऑफ़ सर्विस",
        "footer.builtFor":
            "भारत के लिए बना · धरती के लिए डिज़ाइन किया गया।",
    },
};
